/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const  calendarData =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.calenderData.url,
        maverickPortalApiEndPoint.calenderData.methodType,
        data
      )
      .then(response => {        
        const res = response.data;
        resolve({ res });
      });
  });
};


export { calendarData};
